import { useTranslation } from "react-i18next";

/**
 * AboutPage — static placeholder using the shared brand tokens + Noto Sans.
 *
 * Real copy + links come from the CMS via i18next-backed keys (ROADS-155+).
 * Typography scale exercised here is deliberately the same scale used in
 * apps/marketing (display-4xl/5xl, neutral-800 body, amber-accent rule),
 * so visual QA surfaces regressions against the marketing site.
 */
export default function AboutPage() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto max-w-6xl px-md pt-xl pb-xl sm:px-lg sm:pt-2xl sm:pb-2xl">
      <div className="max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-wide text-neutral-600">
          {t("about.eyebrow")}
        </p>
        <h1 className="mt-sm font-display text-4xl font-bold tracking-tight text-brand-primary sm:text-5xl">
          {t("about.title")}
        </h1>
        <div className="mt-md h-1 w-16 rounded-full bg-brand-accent" aria-hidden="true" />
        <p className="mt-md max-w-prose text-lg text-neutral-800 sm:text-xl">{t("about.body")}</p>
      </div>

      {/*
        Typography specimen — intentionally minimal. Confirms the shared
        Noto Sans stack + display/body scale render identically to the
        marketing site. Replace with real content in ROADS-155+.
      */}
      <div className="mt-2xl grid max-w-4xl gap-lg sm:grid-cols-2">
        <div className="rounded-lg border border-brand-primary/10 bg-white p-md shadow-sm">
          <h2 className="font-display text-2xl font-bold text-brand-primary">
            {t("about.specimen.display.title")}
          </h2>
          <p className="mt-sm text-base text-neutral-700">
            {t("about.specimen.display.body")}
          </p>
        </div>
        <div className="rounded-lg border border-brand-primary/10 bg-white p-md shadow-sm">
          <h2 className="font-display text-2xl font-bold text-brand-primary">
            {t("about.specimen.body.title")}
          </h2>
          <p className="mt-sm text-base text-neutral-700">
            {t("about.specimen.body.body")}
          </p>
        </div>
      </div>
    </section>
  );
}
